import { Location } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, NgForm } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Observable, of } from 'rxjs';
import { FileHandlerService } from 'src/app/services/file-handler.service';
import { HttpService } from 'src/app/services/http.service';
import { LoadingService } from 'src/app/services/loading.service';

@Component({
    selector: 'app-stroop-add',
    templateUrl: './stroop-add.component.html',
    styleUrls: ['./stroop-add.component.scss']
})
export class StroopAddComponent implements OnInit {

    constructor(
        private http: HttpService,
        private el: ElementRef,
        public fileHandler: FileHandlerService,
        private location: Location,
        public loading: LoadingService,
        private toastr: ToastrService) {
    }
    @ViewChild('theForm') theForm: NgForm | undefined;
    private apiPath = 'stroop';
    stayPage: boolean = false;
    formGroup = new FormGroup({
        type: new FormControl(null),
        color_name_id: new FormControl(null),
        color_code_id: new FormControl(null),
        point: new FormControl(10),
        status: new FormControl(1)
    });
    formChanged = false;
    colorList: any[] = [];
    voice: any = { view: '' };

    submitForm(form: any): void {
        if (!form.valid) {
            this.el.nativeElement.querySelectorAll('[formcontrolname].ng-invalid')?.[0]?.focus();
            return;
        }
        let fdata = new FormData();
        fdata.append('voice', this.voice.file);
        fdata.append('data', JSON.stringify(form.value));
        form.disable();
        this.http.PostFile(this.apiPath + '/create', fdata).then((r: any) => {
            form.enable();
            if (r.success) {
                this.toastr.success('Data saved successfully', 'Success');
                if (this.stayPage) {
                    form?.reset();
                    this.theForm?.resetForm();
                } else {
                    this.back();
                }
            } else {
                if (r.response && r.response.wrong) {
                    Object.keys(r.response.wrong).forEach((key) => {
                        if (key != 'id') {
                            form.get(key)?.setErrors({ serverError: r.response.wrong[key][0] });
                            this.el.nativeElement.querySelectorAll('[formcontrolname="' + key + '"]')?.[0]?.focus();
                        }
                    });
                }
            }
        });
    }

    back(): void {
        this.location.back();
    }

    canDeactivate(): Observable<boolean> | boolean {
        if (this.formChanged && (this.formGroup.valid && !this.theForm?.submitted)) {
            const result = window.confirm('There are unsaved changes! Are you sure?');
            return of(result);
        }
        return true;
    }

    async getColor(): Promise<void> {
        const r = await this.http.Get('colors', {});
        this.colorList = r.response?.result?.data || [];
    }

    ngOnInit(): void {
        this.getColor();
        const oldValue = this.formGroup.value;
        this.formGroup.valueChanges.subscribe((e: any) => {
            this.formChanged = (oldValue != e);
        });
    }
}
